<div class="auth-container">
  <div class="container">
    <div class="row">
      <div
        class="login-container col-lg-6 col-sm-12 text-center offset-lg-3"
        >
        @if (isResetWithToken) {
          <section class="login-box text-center">
            <h1 class="title">
              Create Password for Octopus Driver Dashboard
            </h1>
            <h2 class="sub-title">
              Please enter a new password that meets the criteria:
            </h2>
            <form
              class="form text-start form-wrapper reset-password-form"
              (ngSubmit)="onResetSubmit()"
              [formGroup]="resetPasswordForm"
              >
              <section class="form-group text-center mb-4">
                <label class="control-label mb-1" for="email"
                  >Email Address</label
                  >
                  <input
                    class="form-control dd-privacy-allow lower-case"
                    id="reset-email-input"
                    name="email"
                    formControlName="email"
                    readonly
                    type="email"
                    />
                </section>
                <section class="form-group text-center mb-4">
                  <label class="control-label mb-1" for="password"
                    >Create Password</label
                    >
                    <div class="password-input-wrapper">
                      <input
                        class="form-control"
                        name="password"
                        id="reset-password-input"
                        formControlName="password"
                        [type]="showPassword ? 'text' : 'password'"
                        />
                      <button
                        type="button"
                        class="password-toggle-btn"
                        id="reset-password-toggle"
                        (click)="showPassword = !showPassword"
                        aria-label="Toggle password visibility"
                        >
                        <mat-icon>{{ showPassword ? 'visibility' : 'visibility_off' }}</mat-icon>
                      </button>
                    </div>
                    <!-- <p
                                *ngIf="(resetForm['password'].errors?.['required'] || resetForm['password'].errors?.['pattern'] || resetForm['password'].errors?.['minlength'] )&&
                                (resetForm['password'].dirty || resetForm['password'].touched || resetTokenFormSubmitted)"
                    class="error-msg"
                    id="reset-password-required-error-message"
                    >
                    Please lengthen your password to be between 8 and 50 characters(You are currently using
                    {{
                    resetForm['password'].value.trim().length
                    }}
                    characters).
                    Your password must contain at least one letter and one number.
                  </p> -->
                </section>
                <section class="form-group text-center">
                  <label
                    class="control-label mb-1"
                    for="confirm_password"
                    >Confirm Password</label
                    >
                    <div class="password-input-wrapper">
                      <input
                        name="confirm_password"
                        id="reset-confirm-password-input"
                        class="form-control"
                        formControlName="confirm_password"
                        [type]="showConfirmPassword ? 'text' : 'password'"
                        />
                      <button
                        type="button"
                        class="password-toggle-btn"
                        id="reset-confirm-password-toggle"
                        (click)="showConfirmPassword = !showConfirmPassword"
                        aria-label="Toggle confirm password visibility"
                        >
                        <mat-icon>{{ showConfirmPassword ? 'visibility' : 'visibility_off' }}</mat-icon>
                      </button>
                    </div>
                    @if ((resetForm['confirm_password'].errors?.['mustMatch'] )&&
                      (resetForm['confirm_password'].dirty || resetForm['confirm_password'].touched || resetTokenFormSubmitted)) {
                      <p
                        class="error-msg"
                        id="reset-confirm-password-mustmatch-error-message"
                        >
                        Passwords do not match
                      </p>
                    }
                    <div class="text-start instr-block">
                      Your password needs to contain:
                      <ul class="password-criteria-list">
                        <li>
                          @if (resetForm['password'].value && !resetForm['password'].errors?.['minlength'] && (resetForm['password'].dirty || resetForm['password'].touched || resetTokenFormSubmitted)) {
                            <mat-icon
                              class="icon check"
                              id="reset-password-minlength-check-error-icon"
                              >check_circle</mat-icon
                              >
                            }
                            @if (!resetForm['password'].value || (resetForm['password'].errors?.['minlength'] && (resetForm['password'].dirty || resetForm['password'].touched || resetTokenFormSubmitted))) {
                              <mat-icon
                                class="icon uncheck"
                                id="reset-password-minlength-uncheck-error-icon"
                                >radio_button_unchecked</mat-icon
                                >
                              }
                              <span>
                                Between 8 and 50 characters (You are
                                currently using
                                {{
                                resetForm[
                                'password'
                                ].value.trim().length
                                }}
                                characters)
                              </span>
                            </li>
                            <li>
                              @if (resetForm['password'].value && !resetForm['password'].errors?.['pattern'] && (resetForm['password'].dirty || resetForm['password'].touched || resetTokenFormSubmitted)) {
                                <mat-icon
                                  class="icon check"
                                  id="reset-password-pattern-check-error-icon"
                                  >check_circle</mat-icon
                                  >
                                }
                                @if (!resetForm['password'].value || (resetForm['password'].errors?.['pattern'] && (resetForm['password'].dirty || resetForm['password'].touched || resetTokenFormSubmitted))) {
                                  <mat-icon
                                    class="icon uncheck"
                                    id="reset-password-pattern-uncheck-error-icon"
                                    >radio_button_unchecked</mat-icon
                                    >
                                  }
                                  <span>
                                    At least one letter and one number
                                  </span>
                                </li>
                              </ul>
                              <br />
                              Su contraseña debe contener:
                              <ul class="password-criteria-list">
                                <li>
                                  @if (resetForm['password'].value && !resetForm['password'].errors?.['minlength'] && (resetForm['password'].dirty || resetForm['password'].touched || resetTokenFormSubmitted)) {
                                    <mat-icon
                                      class="icon check"
                                      id="reset-password-spanish-minlength-check-error-icon"
                                      >check_circle</mat-icon
                                      >
                                    }
                                    @if (!resetForm['password'].value || (resetForm['password'].errors?.['minlength'] && (resetForm['password'].dirty || resetForm['password'].touched || resetTokenFormSubmitted))) {
                                      <mat-icon
                                        class="icon uncheck"
                                        id="reset-password-spanish--minlength-check-error-icon"
                                        >radio_button_unchecked</mat-icon
                                        >
                                      }
                                      <span>
                                        Entre 8 y 50 caracteres (Actualmente
                                        estás usando
                                        {{
                                        resetForm[
                                        'password'
                                        ].value.trim().length
                                        }}
                                        caracteres)
                                      </span>
                                    </li>
                                    <li>
                                      @if (resetForm['password'].value && !resetForm['password'].errors?.['pattern'] && (resetForm['password'].dirty || resetForm['password'].touched || resetTokenFormSubmitted)) {
                                        <mat-icon
                                          class="icon check"
                                          id="reset-password-spanish-pattern-check-error-icon"
                                          >check_circle</mat-icon
                                          >
                                        }
                                        @if (!resetForm['password'].value || (resetForm['password'].errors?.['pattern'] && (resetForm['password'].dirty || resetForm['password'].touched || resetTokenFormSubmitted))) {
                                          <mat-icon
                                            class="icon uncheck"
                                            id="reset-password-spanish-pattern-uncheck-error-icon"
                                            >radio_button_unchecked</mat-icon
                                            >
                                          }
                                          <span>
                                            Al menos una letra y un número
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </section>
                                  <section class="text-center">
                                    <button
                                      class="btn btn-pink-filled fw-btn"
                                      id="reset-password-submit-btn"
                                      type="submit"
                                [disabled]="
                                    !resetPasswordForm.valid || 
                                    resetTokenFormSubmitted
                                "
                                      >
                                      <p class="load-btn small-btn">
                                        @if (!resetTokenFormSubmitted) {
                                          Reset Password
                                        }
                                        @if (resetTokenFormSubmitted) {
                                          <mat-spinner
                                            [diameter]="17"
                                          ></mat-spinner>
                                          Processing...
                                        }
                                      </p>
                                    </button>
                                  </section>
                                </form>
                              </section>
                            }
                            @if (!isResetWithToken) {
                              <section
                                class="login-box text-center"
                                >
                                <h1 class="title">Password Reset</h1>
                                <h2 class="sub-title">
                                  Please enter your email address registered with Octopus.
                                </h2>
                                <form
                                  class="form text-start form-wrapper"
                                  (ngSubmit)="resetEmailForm && onSubmit()"
                                  [formGroup]="resetEmailForm"
                                  >
                                  <section class="form-group text-center">
                                    <label class="control-label mb-1" for="email"
                                      >Email Address</label
                                      >
                                      <input
                                        class="form-control lower-case"
                                        id="reset-email-input"
                                        name="email"
                                        formControlName="email"
                                        type="email"
                                        />
                                      @if ((resetEmailForm.controls?.['email']?.errors?.['required'] ||
                                        resetEmailForm.controls?.['email']?.errors?.['pattern']) && (resetEmailForm.controls?.['email']?.dirty || resetEmailForm.controls?.['email']?.touched ||
                                        resetFormSubmitted)) {
                                        <p
                                          class="error-msg"
                                          >
                                          Please enter a valid email. Remove white spaces
                                          if any.
                                        </p>
                                      }
                                    </section>
                                    <section class="text-center">
                                      <button
                                        class="btn btn-normal btn-pink mt-3 btn-pink-filled mb-3 email-btn"
                                        id="reset-email-submit-button"
                                        type="submit"
                                        >
                                        Send Reset Email
                                      </button>
                                    </section>
                                    <p class="text-start mt-3">
                                      Want to join the community?
                                      <a [routerLink]="['/join']" id="reset-apply-link"> Apply to join</a>
                                    </p>
                                    <p class="text-start mt-3">
                                      Already have an account?
                                      <a [routerLink]="['/login']" id="reset-signin-link"> Sign in</a>
                                    </p>
                                  </form>
                                </section>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
